import { render, staticRenderFns } from "./PageAddressesUpdate.vue?vue&type=template&id=2e5d4d89&scoped=true&"
import script from "./PageAddressesUpdate.vue?vue&type=script&lang=ts&"
export * from "./PageAddressesUpdate.vue?vue&type=script&lang=ts&"
import style0 from "./PageAddressesUpdate.vue?vue&type=style&index=0&id=2e5d4d89&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5d4d89",
  null
  
)

export default component.exports